(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-size-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  /* PARSER:START */
  var MSF_SHAPES = {
    disc:  { label: 'Disc',  dims: [['d', 'Diameter'], ['h', 'Height']], req: ['d', 'h'], round: true },
    block: { label: 'Block', dims: [['l', 'Length'], ['w', 'Width'], ['t', 'Thickness']], req: ['l', 'w', 't'] },
    rod:   { label: 'Rod',   dims: [['d', 'Diameter'], ['l', 'Length']], req: ['d', 'l'], round: true },
    ring:  { label: 'Ring',  dims: [['od', 'Outer diameter'], ['id', 'Inner diameter'], ['t', 'Thickness']], req: ['od', 'id', 't'], round: true },
    ball:  { label: 'Ball',  dims: [['d', 'Diameter']], req: ['d'], round: true },
    pot:   { label: 'Pot',   dims: [['d', 'Diameter'], ['h', 'Height']], req: ['d'], round: true },
    hook:  { label: 'Hook & eyebolt', dims: [['d', 'Diameter']], req: ['d'], round: true },
    other: { label: 'Other', dims: [], req: [] }
  };
  var MSF_ORDER = ['disc', 'block', 'rod', 'ring', 'ball', 'pot', 'hook', 'other'];

  var NUM = '\\d+(?:\\.\\d+)?';
  var RANGE = NUM + '(?:\\s*-\\s*' + NUM + ')?';
  var GROUP = RANGE + '(?:\\s*x\\s*' + RANGE + ')*';
  var RE_MM = new RegExp('(^|[^a-z0-9.])(' + GROUP + ')\\s*mm(?![a-z])', 'i');
  var RE_BARE = new RegExp('(^|[^a-z0-9.])(' + NUM + '(?:\\s*x\\s*' + NUM + ')+)(?![\\d.]|\\s*(?:cm|m|kg|g|ml)\\b)', 'i');

  function msfNorm(s) {
    return String(s || '')
      .replace(/\s*mm\s*\(D\)\s*[x×]\s*/gi, ' x ')
      .replace(/\s*mm\s*\(H\)/gi, ' mm')
      .replace(/[×✕✖*]/g, 'x')
      .replace(/[Øø⌀]/g, ' ')
      .replace(/[–—−]/g, '-')
      .replace(/\u00a0/g, ' ');
  }
  function msfNum(v) { return Math.round(parseFloat(v) * 1000) / 1000; }
  function msfFmt(n) { return n == null ? '' : String(Math.round(n * 1000) / 1000); }

  /* Split "20 x 10 x 3-4" into [{v:20,txt:'20'},{v:10},{v:4,lo:3,txt:'3–4'}] */
  function msfParts(group) {
    return group.split(/\s*x\s*/i).map(function (p) {
      var r = p.split(/\s*-\s*/);
      if (r.length > 1) {
        var a = msfNum(r[0]), b = msfNum(r[1]);
        if (a === b) return { v: a, txt: msfFmt(a) };
        return { v: Math.max(a, b), lo: Math.min(a, b), txt: msfFmt(a) + '–' + msfFmt(b) };
      }
      var n = msfNum(p);
      return { v: n, txt: msfFmt(n) };
    });
  }

  /* Product type is authoritative: the shape collections (disc-magnets, block-magnets, ...) are built on
     product type, so assigning shape by type keeps the finder counts identical to the collection counts. */
  var MSF_TYPE_MAP = [
    ['disc', /^\s*dis[ck] magnets?\s*$/],
    ['block', /^\s*block magnets?\s*$/],
    ['rod', /^\s*rod magnets?\s*$/],
    ['ring', /^\s*ring magnets?\s*$/],
    ['ball', /^\s*ball magnets?\s*$/],
    ['pot', /^\s*pot magnets?\s*$/],
    ['hook', /^\s*(hook|eyebolt|eye bolt|hook (?:&|and) eyebolt) magnets?\s*$/]
  ];
  /* Non-magnet items (e.g. rubber pads typed as disc) keep their collection shape but get no size filters */
  function msfNonMagnet(p) { return /rubber pad|not a magnet/i.test(String(p.title || '')); }

  function msfShape(p) {
    var t = String(p.title || '').toLowerCase();
    var ty = String(p.product_type || '').toLowerCase();
    var tags = (p.tags || []).join('|').toLowerCase();
    for (var k = 0; k < MSF_TYPE_MAP.length; k++) {
      if (MSF_TYPE_MAP[k][1].test(ty)) return MSF_TYPE_MAP[k][0];
    }
    if (/rubber pad|not a magnet/.test(t)) return 'other';
    if (/dispenser|filter|fishing|tape|sheet|tool|accessor|adhesive|office|special|horseshoe/.test(ty)) return 'other';
    var tests = [
      ['block', /\b(block|cube|cuboid|bar)\b/],
      ['disc', /\b(disc|disk)\b/],
      ['rod', /\b(rod|cylinder)\b/],
      ['ring', /\bring\b/],
      ['ball', /\b(ball|sphere)\b/],
      ['pot', /\bpot\b/],
      ['hook', /\b(hook|eyebolt|eye bolt)\b/]
    ];
    var src = [ty, t, tags];
    for (var s = 0; s < src.length; s++) {
      if (!src[s]) continue;
      if (s > 0 && /fishing|filter magnet|dispenser|pick-up|holder|memo|sewing/.test(t)) return 'other';
      for (var i = 0; i < tests.length; i++) {
        if (tests[i][1].test(src[s])) return tests[i][0];
      }
    }
    return 'other';
  }

  function msfBodyText(p) {
    return String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ');
  }

  /* Returns { shape, dims:{...}, parts:[numbers in title order], label, complete } */
  function msfParse(p) {
    var shape = msfShape(p);
    var def = MSF_SHAPES[shape];
    var title = String(p.title || '');
    var n = msfNorm(title);
    var parts = null;
    var special = null;

    var disp = n.match(/height\s*(\d+(?:\.\d+)?)\s*mm\s*,?\s*(\d+(?:\.\d+)?)\s*mm/i);
    if (disp) {
      special = { d: msfNum(disp[2]), h: msfNum(disp[1]) };
      parts = [{ v: special.d, txt: msfFmt(special.d) }, { v: special.h, txt: msfFmt(special.h) }];
    } else {
      var m = n.match(RE_MM);
      if (m) parts = msfParts(m[2]);
      else if (shape !== 'other') {
        var b = n.match(RE_BARE);
        if (b) parts = msfParts(b[2]);
      }
    }

    var dims = {};
    var v = parts ? parts.map(function (x) { return x.v; }) : [];
    var cube = /\bcube\b/i.test(title);
    if (parts) {
      switch (shape) {
        case 'disc': case 'pot':
          dims.d = v[0]; if (v.length > 1) dims.h = v[1]; break;
        case 'rod':
          dims.d = v[0]; if (v.length > 1) dims.l = v[1]; break;
        case 'ball': case 'hook':
          dims.d = v[0]; break;
        case 'block':
          if (v.length >= 3) { dims.l = v[0]; dims.w = v[1]; dims.t = v[2]; }
          else if (v.length === 1 && cube) { dims.l = dims.w = dims.t = v[0]; parts = [parts[0], parts[0], parts[0]]; }
          else if (v.length === 2) {
            dims.l = v[0]; dims.w = v[1];
            var bm = msfBodyText(p).replace(/[×]/g, 'x').match(new RegExp('(' + NUM + ')\\s*x\\s*(' + NUM + ')\\s*x\\s*(' + NUM + ')\\s*mm', 'i'));
            if (bm && msfNum(bm[1]) === v[0] && msfNum(bm[2]) === v[1]) {
              dims.t = msfNum(bm[3]);
              parts.push({ v: dims.t, txt: msfFmt(dims.t) });
            }
          } else if (v.length === 1) { dims.l = v[0]; }
          break;
        case 'ring':
          dims.od = v[0];
          if (v.length >= 4) { dims.id = Math.min(v[1], v[2]); dims.t = v[v.length - 1]; }
          else if (v.length === 3) {
            dims.id = v[1]; dims.t = v[2];
            var body = msfBodyText(p);
            var bi = body.match(new RegExp('inner diameter (?:of )?(' + NUM + ')\\s*mm', 'i'));
            var bh = body.match(new RegExp('height (?:of )?(' + NUM + ')\\s*mm', 'i'));
            if (bi && bh) {
              var id2 = msfNum(bi[1]), h2 = msfNum(bh[1]);
              if (id2 < dims.od && v.indexOf(id2) > 0 && v.indexOf(h2) > 0) { dims.id = id2; dims.t = h2; }
            }
          } else if (v.length === 2) { dims.t = v[1]; }
          break;
      }
    }
    if (dims.id != null && dims.id >= dims.od) delete dims.id;
    if (shape !== 'other' && msfNonMagnet(p)) dims = {};
    if (parts) v = parts.map(function (x) { return x.v; });

    var complete = shape !== 'other' && def.req.every(function (k) { return dims[k] != null; });

    var label = '';
    if (parts) {
      var pre = def.round || special ? 'Ø' : '';
      if (shape === 'ring' && dims.od != null) {
        label = 'Ø' + msfFmt(dims.od) + (dims.id != null ? ' / Ø' + msfFmt(dims.id) : '') + (dims.t != null ? ' × ' + msfFmt(dims.t) : '') + ' mm';
      } else if (shape === 'pot' || shape === 'disc' || shape === 'rod') {
        label = pre + parts.slice(0, 2).map(function (x) { return x.txt; }).join(' × ') + ' mm';
      } else if (shape === 'ball') {
        label = 'Ø' + parts[0].txt + ' mm';
      } else if (shape === 'other' && /\bmm\b[^a-z]*\bor\b/i.test(n)) {
        label = '';
        v = [];
      } else {
        label = pre + parts.map(function (x) { return x.txt; }).join(' × ') + ' mm';
      }
    }
    return { shape: shape, dims: dims, parts: v, label: label, complete: complete };
  }

  /* Minimal record kept in memory / sessionStorage */
  function msfRecord(p) {
    var r = msfParse(p);
    var prices = (p.variants || []).map(function (x) { return Math.round(parseFloat(x.price) * 100); }).filter(function (x) { return !isNaN(x); });
    var img = (p.images && p.images[0]) || p.image || null;
    return {
      h: p.handle,
      t: p.title,
      ty: p.product_type || '',
      s: r.shape,
      d: r.dims,
      n: r.parts,
      lb: r.label,
      c: r.complete,
      p: prices.length ? Math.min.apply(null, prices) : null,
      pm: prices.length ? Math.max.apply(null, prices) : null,
      a: (p.variants || []).some(function (x) { return x.available; }),
      i: img ? img.src : '',
      iw: img ? img.width : 0,
      ih: img ? img.height : 0
    };
  }

  /* Size query "10x3", "20 x 10 x 5 mm", "Ø10" -> [10,3]; words -> tokens */
  function msfQuery(q) {
    var s = msfNorm(String(q || '').toLowerCase())
      .replace(/(\d),(\d)/g, '$1.$2')
      .replace(/(\d)\s*(?:x|by)\s*(?=\d)/g, '$1x')
      .replace(/(\d)\s+mm\b/g, '$1mm');
    var nums = [];
    var words = [];
    var sizeRe = new RegExp('^(' + NUM + '(?:x' + NUM + ')*)(?:mm)?$');
    s.split(/[\s,;/]+/).forEach(function (tok) {
      tok = tok.replace(/^[^a-z0-9]+|[^a-z0-9.]+$/g, '').replace(/\.$/, '');
      if (!tok || tok === 'mm' || tok === 'x') return;
      var m = tok.match(sizeRe);
      if (m) { if (!nums.length) nums = m[1].split('x').map(msfNum); }
      else words.push(tok);
    });
    return { nums: nums, words: words };
  }
  function msfMatchQuery(rec, qq) {
    if (qq.words.length) {
      var hay = (rec.t + ' ' + rec.ty + ' ' + MSF_SHAPES[rec.s].label).toLowerCase();
      for (var i = 0; i < qq.words.length; i++) {
        var w = qq.words[i];
        if (hay.indexOf(w) === -1 && hay.indexOf(w.replace(/s$/, '')) === -1) return false;
      }
    }
    if (qq.nums.length) {
      var arr = rec.n || [];
      if (!arr.length) return false;
      var eq = function (a, b) { return Math.abs(a - b) < 0.0005; };
      if (qq.nums.length === 1) return arr.some(function (x) { return eq(x, qq.nums[0]); });
      if (qq.nums.length > arr.length) return false;
      for (var j = 0; j < qq.nums.length; j++) if (!eq(arr[j], qq.nums[j])) return false;
      return true;
      return false;
    }
    return true;
  }
  /* PARSER:END */

  /* ---------- UI ---------- */
  var DIM_KEYS = ['d', 'h', 'l', 'w', 't', 'od', 'id'];
  var EU = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(',');
  var CACHE_TTL = 30 * 60 * 1000;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents, format) {
    function fmt(n, dec, th, ds) {
      if (isNaN(n) || n == null) return '0';
      var fixed = (n / 100).toFixed(dec).split('.');
      return fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (fixed[1] ? ds + fixed[1] : '');
    }
    if (!format) return '€' + fmt(cents, 2, '.', ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function sameNum(a, b) { return a != null && b != null && Math.abs(a - b) < 0.0005; }

  class MsSizeFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-msf-config]').textContent); } catch (e) { this.cfg = {}; }
      this.cfg.pageSize = this.cfg.pageSize || 24;
      this.state = { shape: 'all', q: '', sort: 'size', f: {} };
      this.limit = this.cfg.pageSize;
      this.el = {
        shapes: this.querySelector('[data-msf-shapes]'),
        dims: this.querySelector('[data-msf-dims]'),
        q: this.querySelector('[data-msf-q]'),
        sort: this.querySelector('[data-msf-sort]'),
        clear: this.querySelector('[data-msf-clear]'),
        count: this.querySelector('[data-msf-count]'),
        grid: this.querySelector('[data-msf-grid]'),
        empty: this.querySelector('[data-msf-empty]'),
        more: this.querySelector('[data-msf-more]'),
        status: this.querySelector('[data-msf-status]'),
        form: this.querySelector('[data-msf-form]')
      };
      this.readUrl();
      this.bind();
      this.load();
    }

    readUrl() {
      var p = new URLSearchParams(window.location.search);
      var sh = p.get('shape');
      if (sh && (MSF_SHAPES[sh] || sh === 'all')) this.state.shape = sh;
      this.state.q = p.get('q') || '';
      var so = p.get('sort');
      if (so && /^(size|size-desc|price|price-desc)$/.test(so)) this.state.sort = so;
      var f = {};
      if (this.state.shape !== 'all') {
        MSF_SHAPES[this.state.shape].dims.forEach(function (d) {
          var v = p.get(d[0]);
          if (v != null && v !== '' && !isNaN(parseFloat(v))) f[d[0]] = parseFloat(v);
        });
      }
      this.state.f = f;
      this.el.q.value = this.state.q;
      this.el.sort.value = this.state.sort;
    }

    writeUrl() {
      if (window.Shopify && window.Shopify.designMode) return;
      var p = new URLSearchParams(window.location.search);
      ['shape', 'q', 'sort'].concat(DIM_KEYS).forEach(function (k) { p.delete(k); });
      if (this.state.shape !== 'all') p.set('shape', this.state.shape);
      var f = this.state.f;
      Object.keys(f).forEach(function (k) { p.set(k, msfFmt(f[k])); });
      if (this.state.q) p.set('q', this.state.q);
      if (this.state.sort !== 'size') p.set('sort', this.state.sort);
      var qs = p.toString();
      history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    }

    bind() {
      var self = this;
      this.el.shapes.addEventListener('click', function (e) {
        var b = e.target.closest('[data-shape]');
        if (!b) return;
        var sh = b.getAttribute('data-shape');
        if (sh === self.state.shape) return;
        self.state.shape = sh;
        self.state.f = {};
        self.limit = self.cfg.pageSize;
        self.update(true);
      });
      this.el.dims.addEventListener('change', function (e) {
        var s = e.target.closest('select[data-dim]');
        if (!s) return;
        var k = s.getAttribute('data-dim');
        if (s.value === '') delete self.state.f[k]; else self.state.f[k] = parseFloat(s.value);
        self.limit = self.cfg.pageSize;
        self.update(true);
      });
      var t;
      this.el.q.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          self.state.q = self.el.q.value.trim();
          self.limit = self.cfg.pageSize;
          self.update(true);
        }, 200);
      });
      this.el.form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(t);
        self.state.q = self.el.q.value.trim();
        self.update(true);
      });
      this.el.sort.addEventListener('change', function () {
        self.state.sort = self.el.sort.value;
        self.update(true);
      });
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-msf-clear]')) {
          self.state = { shape: 'all', q: '', sort: self.state.sort, f: {} };
          self.el.q.value = '';
          self.limit = self.cfg.pageSize;
          self.update(true);
        } else if (e.target.closest('[data-msf-retry]')) {
          self.load(true);
        }
      });
      this.el.more.addEventListener('click', function () {
        var first = self.limit;
        self.limit += self.cfg.pageSize;
        self.renderGrid();
        var card = self.el.grid.children[first];
        if (card) { var a = card.querySelector('a'); if (a) a.focus({ preventScroll: false }); }
      });
    }

    cacheKey() { return 'ms-size-finder:v3:' + (this.cfg.root || '/') + ':' + this.cfg.collection + ':' + (this.cfg.currency || ''); }

    async load(force) {
      var self = this;
      this.setStatus('loading');
      var key = this.cacheKey();
      if (!force) {
        try {
          var c = JSON.parse(sessionStorage.getItem(key) || 'null');
          if (c && c.ts && Date.now() - c.ts < CACHE_TTL && Array.isArray(c.items)) {
            this.items = c.items;
            this.afterLoad();
            return;
          }
        } catch (e) {}
      }
      try {
        var root = (this.cfg.root || '/').replace(/\/?$/, '/');
        var all = [];
        for (var page = 1; page <= 40; page++) {
          var res = await fetch(root + 'collections/' + encodeURIComponent(this.cfg.collection || 'all') + '/products.json?limit=250&page=' + page, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          var data = await res.json();
          var list = (data && data.products) || [];
          if (!list.length) break;
          for (var i = 0; i < list.length; i++) all.push(msfRecord(list[i]));
          if (list.length < 250) break;
        }
        var hide = String(this.cfg.hideTypes || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
        if (hide.length) all = all.filter(function (r) { return hide.indexOf(String(r.ty).toLowerCase()) === -1; });
        this.items = all;
        try { sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), items: all })); } catch (e) {}
        this.afterLoad();
      } catch (err) {
        console.error('[ms-size-finder]', err);
        self.setStatus('error');
      }
    }

    afterLoad() {
      this.setStatus('ready');
      var counts = { all: this.items.length };
      this.items.forEach(function (r) {
        counts[r.s] = (counts[r.s] || 0) + 1;
        if (r.s !== 'other' && !r.n.length) counts.other = (counts.other || 0) + 1;
      });
      this.counts = counts;
      if (this.state.shape !== 'all' && !counts[this.state.shape]) { this.state.shape = 'all'; this.state.f = {}; }
      this.update(false);
    }

    setStatus(s) {
      this.setAttribute('data-status', s);
      var st = this.el.status;
      if (s === 'loading') {
        st.hidden = false;
        st.innerHTML = '<span class="msf__spinner" aria-hidden="true"></span> Loading magnets…';
        this.el.grid.innerHTML = new Array(9).join('<li class="msf__card msf__card--skeleton" aria-hidden="true"><span class="msf__media"></span><span class="msf__sk-line"></span><span class="msf__sk-line msf__sk-line--short"></span></li>');
      } else if (s === 'error') {
        st.hidden = false;
        st.innerHTML = 'The product list could not be loaded. <button type="button" class="msf__link-btn" data-msf-retry>Try again</button>';
        this.el.grid.innerHTML = '';
      } else {
        st.hidden = true;
        st.innerHTML = '';
      }
    }

    /* products in current shape + query, optionally ignoring one dim filter */
    filtered(skipKey) {
      var st = this.state;
      var qq = msfQuery(st.q);
      var keys = Object.keys(st.f).filter(function (k) { return k !== skipKey; });
      return this.items.filter(function (r) {
        if (st.shape === 'other') { if (!(r.s === 'other' || !r.n.length)) return false; }
        else if (st.shape !== 'all' && r.s !== st.shape) return false;
        for (var i = 0; i < keys.length; i++) {
          if (!sameNum(r.d[keys[i]], st.f[keys[i]])) return false;
        }
        return msfMatchQuery(r, qq);
      });
    }

    sortList(list) {
      var st = this.state;
      var shapeDims = st.shape !== 'all' && st.shape !== 'other' ? MSF_SHAPES[st.shape].dims.map(function (d) { return d[0]; }) : null;
      var order = MSF_ORDER;
      function sizeCmp(a, b) {
        var aa, bb;
        if (shapeDims) {
          aa = shapeDims.map(function (k) { return a.d[k]; });
          bb = shapeDims.map(function (k) { return b.d[k]; });
        } else { aa = a.n; bb = b.n; }
        var ea = !aa.length || aa[0] == null, eb = !bb.length || bb[0] == null;
        if (ea !== eb) return ea ? 1 : -1;
        for (var i = 0; i < Math.max(aa.length, bb.length); i++) {
          var x = aa[i], y = bb[i];
          if (x == null && y == null) continue;
          if (x == null) return 1;
          if (y == null) return -1;
          if (x !== y) return x - y;
        }
        var so = order.indexOf(a.s) - order.indexOf(b.s);
        return so || a.t.localeCompare(b.t);
      }
      var cmp = sizeCmp;
      if (st.sort === 'size-desc') cmp = function (a, b) {
        var ea = !a.n.length, eb = !b.n.length;
        if (ea !== eb) return ea ? 1 : -1;
        return sizeCmp(b, a);
      };
      else if (st.sort === 'price') cmp = function (a, b) { return (a.p == null) - (b.p == null) || a.p - b.p || sizeCmp(a, b); };
      else if (st.sort === 'price-desc') cmp = function (a, b) { return (a.p == null) - (b.p == null) || b.p - a.p || sizeCmp(a, b); };
      return list.slice().sort(cmp);
    }

    update(push) {
      if (!this.items) return;
      this.renderShapes();
      this.renderDims();
      this.results = this.sortList(this.filtered());
      this.renderGrid();
      var hasFilter = this.state.shape !== 'all' || this.state.q || Object.keys(this.state.f).length;
      this.el.clear.hidden = !hasFilter;
      if (push) this.writeUrl();
    }

    renderShapes() {
      var self = this;
      this.el.shapes.querySelectorAll('[data-shape]').forEach(function (b) {
        var sh = b.getAttribute('data-shape');
        var n = self.counts[sh] || 0;
        b.hidden = sh !== 'all' && n === 0;
        b.setAttribute('aria-pressed', sh === self.state.shape ? 'true' : 'false');
        var c = b.querySelector('.msf__shape-count');
        if (c) c.textContent = n;
      });
    }

    renderDims() {
      var self = this;
      var st = this.state;
      var wrap = this.el.dims;
      if (st.shape === 'all' || st.shape === 'other') {
        wrap.innerHTML = '';
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      var def = MSF_SHAPES[st.shape];
      var html = '';
      def.dims.forEach(function (d) {
        var k = d[0];
        var pool = self.filtered(k);
        var counts = {};
        pool.forEach(function (r) {
          var v = r.d[k];
          if (v == null) return;
          var key = msfFmt(v);
          counts[key] = (counts[key] || 0) + 1;
        });
        var sel = st.f[k] != null ? msfFmt(st.f[k]) : '';
        if (sel && !counts[sel]) counts[sel] = 0;
        var vals = Object.keys(counts).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        var id = self.id + '-' + k;
        html += '<div class="msf__field"><label for="' + id + '">' + esc(d[1]) + ' <span class="msf__unit">(mm)</span></label>' +
          '<select id="' + id + '" data-dim="' + k + '"><option value="">Any</option>' +
          vals.map(function (v) {
            return '<option value="' + v + '"' + (v === sel ? ' selected' : '') + '>' + (def.round && k !== 't' && k !== 'h' && k !== 'l' ? 'Ø' : '') + v + ' mm (' + counts[v] + ')</option>';
          }).join('') + '</select></div>';
      });
      var active = document.activeElement && wrap.contains(document.activeElement) ? document.activeElement.getAttribute('data-dim') : null;
      wrap.innerHTML = html;
      if (active) { var el = wrap.querySelector('[data-dim="' + active + '"]'); if (el) el.focus(); }
    }

    priceHtml(r) {
      var c = this.cfg;
      if (r.p == null) return '';
      var from = r.pm != null && r.pm !== r.p ? 'From ' : '';
      var h = '<span class="msf__price">' + from + '<bdi>' + esc(formatMoney(r.p, c.moneyFormat)) + '</bdi> <span class="msf__vat">excl. VAT</span></span>';
      if (c.showInclVat && !c.taxesIncluded) {
        if (EU.indexOf(c.country || 'BE') !== -1) {
          var incl = Math.round(r.p * (100 + (c.vatRate || 21)) / 100);
          h += '<small class="msf__incl">' + from + '<bdi>' + esc(formatMoney(incl, c.moneyFormat)) + '</bdi> ' + esc(c.vatLabel || 'incl. VAT') + '</small>';
        } else {
          h += '<small class="msf__incl">No EU VAT outside the EU.</small>';
        }
      }
      return h;
    }

    renderGrid() {
      var self = this;
      var list = this.results || [];
      var root = (this.cfg.root || '/').replace(/\/?$/, '/');
      var shown = list.slice(0, this.limit);
      this.el.grid.innerHTML = shown.map(function (r) {
        var img = r.i
          ? '<img src="' + esc(imgUrl(r.i, 360)) + '" srcset="' + [180, 270, 360, 540, 720].map(function (w) { return esc(imgUrl(r.i, w)) + ' ' + w + 'w'; }).join(', ') + '" sizes="(min-width: 990px) 280px, (min-width: 750px) 30vw, 46vw" width="' + (r.iw || 400) + '" height="' + (r.ih || 400) + '" alt="" loading="lazy" decoding="async">'
          : '';
        return '<li class="msf__card' + (r.a ? '' : ' msf__card--soldout') + '"><a class="msf__card-link" href="' + root + 'products/' + encodeURIComponent(r.h) + '">' +
          '<span class="msf__media">' + img + (r.a ? '' : '<span class="msf__soldout">Sold out</span>') + '</span>' +
          '<span class="msf__body">' +
          (r.lb ? '<span class="msf__badge"><span class="msf__visually-hidden">Size: </span>' + esc(r.lb) + '</span>' : '') +
          '<span class="msf__name">' + esc(r.t) + '</span>' +
          '<span class="msf__prices">' + self.priceHtml(r) + '</span>' +
          '</span></a></li>';
      }).join('');
      var n = list.length;
      this.el.count.textContent = n === 1 ? '1 product found' : n + ' products found';
      this.el.empty.hidden = n !== 0;
      this.el.grid.hidden = n === 0;
      var rest = n - shown.length;
      this.el.more.hidden = rest <= 0;
      if (rest > 0) this.el.more.textContent = 'Show more (' + rest + ' more)';
    }
  }

  if (!customElements.get('ms-size-finder')) customElements.define('ms-size-finder', MsSizeFinder);
})();

  } catch(e) { console.error(e); }
})();
})();
